import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  LearnableFeature,
} from "@dndModels";

import FilterBox from "@dndComponents/filtering/FilterBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import StringBox from "@components/input/strings/StringBox";

interface Props { 
  obj: LearnableFeature;
  disabled: boolean;
  change_time: number;
  height: number;
  onChange: (changed: LearnableFeature) => void; 
}

export default function LearnableFeatureInput({
  obj,
  disabled,
  change_time,
  height,
  onChange,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [filter, setFilter] = useState({});
  const [fields, setFields] = useState<string[]>([]);

  // eslint-disable-next-line
  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      cleanFilter({...obj.obj_filter});
      getFields(obj.type);
    }
  });

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const cleanFilter = (new_filter: any) => {
    if (new_filter["id"]) {
      switch (obj.type) {
        // case "Adaptation": case "adaptation": new_filter["adaptation"] = new_filter["id"]; break;
        // case "Transform": case "transform": new_filter["transform"] = new_filter["id"]; break;
        case "Creature": case "creature": new_filter["creature"] = new_filter["id"]; break;
      }
      delete new_filter["id"];
    }
    setFilter(new_filter);
    setReloading(true);
  }
  
  const updateFilter = (changed: any = null) => {
    const new_obj = obj;
    const new_filter = {...changed};
    switch (obj.type) {
      case "Adaptation": case "adaptation": 
        if (new_filter["adaptation"]) {
          new_filter["id"] = new_filter["adaptation"];
          delete new_filter["adaptation"];
        }
      break;
      case "Transform": case "transform": 
        if (new_filter["transform"]) {
          new_filter["id"] = new_filter["transform"];
          delete new_filter["transform"];
        }
      break;
      case "Creature": case "creature": 
        if (new_filter["creature"]) {
          new_filter["id"] = new_filter["creature"];
          delete new_filter["creature"];
        }
      break;
    }
    new_obj.obj_filter = new_filter;
    onChange(new_obj);
  }

  const getFields = (type: string) => {
    switch (type) {
      case "Adaptation": setFields(["source_book","transform_type","adaptation"]); break;
      case "Transform": setFields(["source_book","transform_type","transform"]); break;
      case "Creature": setFields([
        "source_book",
        "creature_type",
        "subtype",
        "min_cr",
        "max_cr",
        "flying",
        "swimming",
        "creature_size",
        "environments",
        "settings",
        "native_planes",
        "effect_type",
        "attack_type",
        "creature"]); break;
      default: setFields([]); break;
    }
  }

  return (
    <div>
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <SelectStringBox
            name="Type of Learnable"
            options={["Adaptation","Transform","Skill", "Tool", "Language", "Eldritch Invocation", "Spell", "Creature", "CraftingRecipe"]}
            value={obj.type}
            disabled={disabled}
            onChange={(changed: string) => {
              const new_obj = obj;
              new_obj.type = changed;
              new_obj.obj_filter = {};
              new_obj.usage_key = "";
              onChange(new_obj);
              getFields(changed);
              setReloading(true);
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          { !reloading &&
            <FilterBox
              the_filter={filter}
              fields={fields}
              dont_use_api
              // log_it
              disabled={disabled}
              onChange={updateFilter}
            />
          }
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <StringBox
            name="Usage"
            value={obj.usage_key}
            disabled={disabled}
            onBlur={(changed: string) => {
              const new_obj = obj;
              new_obj.usage_key = changed;
              onChange(new_obj);
            }}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <StringBox
            name="Count"
            value={`${obj.count}`}
            type="number"
            disabled={disabled}
            onBlur={(changed: string) => {
              const new_obj = obj;
              new_obj.count = +changed;
              onChange(new_obj);
            }}
          />
        </Grid> */}
      </Grid>
    </div>
  ); 
}